
import { isServer } from '../store';
import { LogCategory,  log } from './logger';

export default {

    callHost(str) {
        if ( !isServer) {
            var args = str;
            if ( str.startsWith("action OpenUrl"))
                console.log(str); // for debugging

            var str = 'hm3Callback.args = "' + args + '"; hm3Callback.execute();';
            log(LogCategory.callback,"send to host " + args);
            try {
                eval(str);
            } catch(e) {
                log(LogCategory.error,"error call host " + e.message );
            }
        }
    },

    sendTokenToHost(token) {
        // don't log the token itself
        console.log("sending token back to host");
        this.callHost("action Token " + token);
    },

    openUrl(url) {
        this.callHost("action OpenUrl " + url);
    },

    openPaypal(url) {
        this.callHost("action OpenPaypal " + url);
    },

    reloadLicense() {
        this.callHost("action ReloadLicense");
    },

    switchToFreemium(url) {
        this.callHost("action SwitchToFreemium " + url);
    },

    startUsingApp() {
        this.callHost("action StartUsingApp");
    },

    continueTrial() {
        this.callHost("action ContinueTrial");
    },

    close() {
        this.callHost("action Close");
    },
    switchUser() {
        this.callHost("action SwitchUser");
    },
    simpleAction(action) {
        this.callHost("action " + action);
    },

    needsReloadLicense() {
        this.callHost("action NeedsReloadLicense");
    },

    netellerRedirect(url) {
        // at this point (7 feb 2019), store doesn't send https
        if ( url.indexOf("redirect_uri=http%") >= 0)
            url = url.replace("redirect_uri=http%", "redirect_uri=https%");

        this.callHost("action NetellerRedirect " + url);
    },

    // sends the http status from the licensing/store
    sendHttpStatusToHost(licensing, store) {
        this.callHost("action HttpStatus " + licensing + " " + store);
    }

}



// WEBPACK FOOTER //
// ./src/api/callHostApp.js